import { render } from "./DicomSettingsRow.vue?vue&type=template&id=822e3bcc&scoped=true"
import script from "./DicomSettingsRow.vue?vue&type=script&lang=js"
export * from "./DicomSettingsRow.vue?vue&type=script&lang=js"

import "./DicomSettingsRow.vue?vue&type=style&index=0&id=822e3bcc&scoped=true&lang=css"

import exportComponent from "/Users/erik/IdeaProjects/reportx/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-822e3bcc"]])

export default __exports__